// eslint-disable-next-line no-unused-vars
import { ISalesTSDItem } from 'pages/WirelineEngagements/shared/AddOrderModalForm/product.model';

export const convertTSDsDataToOptions = (tsdList: ISalesTSDItem[]) => tsdList.map(
  (item) => ({ text: item.name, value: item.id }),
);
